import(/* webpackMode: "eager" */ "/Users/joseph/projects/moneyline/client/node_modules/@splidejs/react-splide/dist/css/splide-core.min.css");
;
import(/* webpackMode: "eager", webpackExports: ["BlocksRenderer"] */ "/Users/joseph/projects/moneyline/client/node_modules/@strapi/blocks-react-renderer/dist/BlocksRenderer.mjs");
;
import(/* webpackMode: "eager" */ "/Users/joseph/projects/moneyline/client/src/app/(public)/sportsbooks/[slug]/styles.module.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/joseph/projects/moneyline/client/src/components/ExternalLinksHandler.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/joseph/projects/moneyline/client/src/components/primitives/accordion.tsx");
;
import(/* webpackMode: "eager" */ "/Users/joseph/projects/moneyline/client/src/components/primitives/button.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/joseph/projects/moneyline/client/src/components/primitives/icon.tsx");
;
import(/* webpackMode: "eager" */ "/Users/joseph/projects/moneyline/client/src/components/sportsbook/styles.module.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/joseph/projects/moneyline/client/src/components/sportsbook/table-of-contents.tsx");
